import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import newAPI from "api/newAPI";

// NEWS
const getNews = createAsyncThunk(
  "GET_NEWS",
  async (_arg, { rejectWithValue }) => {
    try {
      const res = await newAPI.getNews(_arg);
      if( res.sorrypage == '0') {
        return { 
          new: {},
          isInLine: true 
        };
      }
      return {
        news: res.data.news,
        isInLine: res.data.isInLine
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getInitNew = createAsyncThunk(
  "GET_INIT_NEWS",
  async (_arg, { rejectWithValue }) => {
    try {
      const res = await newAPI.getInitNew(_arg);
      if( res.sorrypage == '0') {
        return { 
          new: {},
          isInLine: true 
        };
      }
      return {
        news: res.data.news,
        isInLine: res.data.isInLine
      };
      
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getNew = createAsyncThunk(
  "GET_NEW",
  async (_arg, { rejectWithValue }) => {
    try {
      const res = await newAPI.getNew(_arg);
      if( res.sorrypage == '0') {
        return { 
          new: {},
          isInLine: true 
        };
      }
      return {
        new: res.data.news,
        isInLine: res.data.isInLine
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  news: null,
  new: null,
  newsInit: null,
  isInLine: null
};

const newSlice = createSlice({
  name: "new",
  initialState,
  extraReducers: {
    // NEWS
    [getNews.fulfilled]: (state, action) => {
      state.news = action.payload.news;
      state.isInLine = action.payload.isInLine;
    },
    [getInitNew.fulfilled]: (state, action) => {
      state.newsInit = action.payload;
    },
    [getNew.fulfilled]: (state, action) => {
      state.new = action.payload.new;
      state.isInLine = action.payload.isInLine;
    },
  },
});

const { reducer } = newSlice;
export { getNews, getNew, getInitNew };
export default reducer;
